import Checkbox from '$tablet-app/src/app/components/Checkbox';
import Spacer from '$tablet-app/src/app/components/Spacer';
import { color } from '$tablet-app/src/app/theme';
import { findAndUpdateRecord } from '$tablet-app/src/app/utils/arrays';
import { ChatCheckListItem } from '@akin-home/chat';
import { CheckListItem } from '@akin-home/checklists';
import {
  useGetTaskList,
  useUpdateTaskListItem,
} from '@akin-home/checklists/frontend';
import { Text } from '@akin-home/text/native';
import React from 'react';
import { StyleSheet } from 'react-native';
import { ChatItemDialogBody, ChatItemHeader } from '../../ChatItem';
import { useDismissChatItemDialog } from '../ChatItemDialog';
import { ChatItemDialogProps } from '../ChatItemDialog/ChatItemDialogProps';

export const ChecklistChatDialog = (
  props: ChatItemDialogProps<ChatCheckListItem>
) => {
  const {
    chat_item: {
      data: { id },
    },
  } = props;
  const onDismiss = useDismissChatItemDialog();

  const { list } = useGetTaskList({ id });

  const updateChecklist = useUpdateTaskListItem();

  const onChange = (item: CheckListItem) => {
    if (!list) return;

    updateChecklist({
      id: list.id,
      checklist: findAndUpdateRecord(list.checklist, item),
    });
  };

  return (
    <>
      <ChatItemHeader title="lists" icon="tasks" onDismiss={onDismiss} />
      {list ? (
        <ChatItemDialogBody>
          <Text variant="h3" weight="bold" color="white">
            {list.title}
          </Text>
          <Spacer height="20px" />
          {list.checklist.map((item) => (
            <React.Fragment key={item.id}>
              <CheckListItemLine item={item} onChange={onChange} />
              <Spacer height="16px" />
            </React.Fragment>
          ))}
        </ChatItemDialogBody>
      ) : null}
    </>
  );
};

interface CheckListItemProps {
  item: CheckListItem;
  onChange(item: CheckListItem): void;
}

const CheckListItemLine = (props: CheckListItemProps) => {
  const { item, onChange } = props;

  const onChangeCheckbox = (checked: boolean) => onChange({ ...item, checked });

  return (
    <Checkbox
      value={!!item.checked}
      label={item.title}
      onChange={onChangeCheckbox}
      textStyle={styles.checkboxText}
    />
  );
};

const styles = StyleSheet.create({
  checkboxText: {
    color: color.primaryText,
  },
});
